<template lang="pug">
.textblock
    h2.textblock__title.q-pa-none {{ title }}
    .textblock__info {{ info }}
</template>

<script>
export default {
    name: 'Textblock',
    props: {
        title: {
            type: String,
            required: true,
        },
        info: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss">
.textblock {
    &__title {
        color: $primary;
        line-height: 27px;
        padding: 8px 0;

        font: {
            size: 24px;
            weight: 700;
        }

        @media (max-width: 960px) {
            font-size: 18px;
        }
    }

    &__info {
        color: $primary;
        line-height: 23px;
        padding: 8px 0;

        font: {
            size: 18px;
            weight: 400;
        }

        @media (max-width: 960px) {
            font-size: 14px;
        }
    }
}
</style>